import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import preventDefault from 'garaje/helpers/prevent-default';
import type AjaxFetchService from 'garaje/services/ajax-fetch';
import type FlashMessagesService from 'garaje/services/flash-messages';

interface EmailFoundComponentSignature {
  Args: {
    email: string;
    changeEmail: (email: string) => void;
  };
}

export default class EmailFoundComponent extends Component<EmailFoundComponentSignature> {
  @service declare flashMessages: FlashMessagesService;
  @service declare ajaxFetch: AjaxFetchService;
  @service declare store: StoreService;

  @action
  sendConfirmation(): void {
    void this.resend.perform();
  }

  resend = dropTask(async () => {
    try {
      const path = 'resend-confirmation';
      const adapter = this.store.adapterFor('user');
      const url = adapter.buildURL('user');

      await this.ajaxFetch.request(`${url}/${path}`, {
        contentType: 'application/vnd.api+json',
        type: 'POST',
        data: JSON.stringify({
          data: {
            attributes: {
              email: this.args.email,
            },
          },
        }),
      });

      this.flashMessages.showFlash('success', 'Confirmation sent!');
    } catch (_e) {
      this.flashMessages.showFlash('error', 'Confirmation email not sent. Try again later.');
    }
  });

  <template>
    <div class="messageBox messageBox--email-confirmation">
      <h3 class="text-center mb-8">Email address found</h3>
      <div>
        <p class="text-center">We've sent a confirmation email to
          <strong>{{@email}}</strong>. Check your email and click the confirmation link to continue.</p>
        <div class="flex">
          <a
            href="#"
            {{on "click" (preventDefault (fn @changeEmail @email))}}
            class="btn btn--medium btn--brandOutlineFill mr-2 mb-4 flex-auto min-w-0 min-h-0"
          >Change email</a>
          <a
            href="#"
            data-test-resend-confirmation-email
            {{on "click" (preventDefault this.sendConfirmation)}}
            class="btn btn--medium btn--brandOutlineFill ml-2 mb-4 flex-auto min-w-0 min-h-0"
          >Resend email</a>
        </div>
      </div>
    </div>
  </template>
}
